import { useRouteBreadCrumb } from '@jotta/hooks/useRouteBreadCrumb'
import { NavLink, Outlet } from 'react-router-dom'
import { BizBoundary } from './components/BizBoundary'
import { BizUserLimitAlert } from './components/BizUserLimitAlert'
import { useEffect } from 'react'
import { navigate } from '@jotta/router'
import { useGetCustomer } from '@jotta/grpc-connect-client/customer'
import { AccountType } from '@jotta/grpc-connect-openapi/esm/openapi/customer/customer.v2_pb'
import { ErrorPage } from '@jotta/ui/ErrorPage'

export function BizLayout() {
  const crumbs = useRouteBreadCrumb()
  const query = useGetCustomer()
  const customer = query.data
  const company = customer?.business
  const businessAdmin =
    company && customer && customer.accountType === AccountType.BUSINESS_ADMIN
  // Redirect to files if customer has fetched and is not a business admin
  const shouldRedirect = customer && !businessAdmin
  useEffect(() => {
    if (shouldRedirect) {
      navigate('/web/sync')
    }
  }, [shouldRedirect])

  if (businessAdmin) {
    return (
      <div className="px-6 py-4">
        <ul className="breadcrumb py-4">
          <li className="body-md-sh">
            <NavLink end to="/biz">
              {company.name}
            </NavLink>
          </li>
          {crumbs.map((crumb, index) => (
            <li key={index}>{crumb}</li>
          ))}
        </ul>
        <div className="relative flex flex-col gap-3 pb-16 lg:pb-4">
          <BizBoundary>
            <BizUserLimitAlert />
            <Outlet />
          </BizBoundary>
        </div>
      </div>
    )
  }
  if (query.isLoading) {
    return <div className="loading"></div>
  }
  if (query.isError) {
    return <ErrorPage error={query.error} />
  }
}
